"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DhsBackgroundCheckStatus = void 0;
exports.instanceOfDhsBackgroundCheckStatus = instanceOfDhsBackgroundCheckStatus;
exports.DhsBackgroundCheckStatusFromJSON = DhsBackgroundCheckStatusFromJSON;
exports.DhsBackgroundCheckStatusFromJSONTyped = DhsBackgroundCheckStatusFromJSONTyped;
exports.DhsBackgroundCheckStatusToJSON = DhsBackgroundCheckStatusToJSON;
exports.DhsBackgroundCheckStatusToJSONTyped = DhsBackgroundCheckStatusToJSONTyped;
/**
 *
 * @export
 */
exports.DhsBackgroundCheckStatus = {
    NotRequested: 'NOT_REQUESTED',
    Pending: 'PENDING',
    Eligible: 'ELIGIBLE',
    NotEligible: 'NOT_ELIGIBLE'
};
function instanceOfDhsBackgroundCheckStatus(value) {
    for (const key in exports.DhsBackgroundCheckStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.DhsBackgroundCheckStatus, key)) {
            if (exports.DhsBackgroundCheckStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function DhsBackgroundCheckStatusFromJSON(json) {
    return DhsBackgroundCheckStatusFromJSONTyped(json, false);
}
function DhsBackgroundCheckStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function DhsBackgroundCheckStatusToJSON(value) {
    return value;
}
function DhsBackgroundCheckStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=DhsBackgroundCheckStatus.js.map